let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("68Kzv"), load("3NvtU"), load("7zMjZ"), load("a1dBM"), load("j7IF9")]).then(() => parcelRequire('6Pefo'));